/**
 * @fileoverview Entity Picker entity type section header presentation component
 */
// @ts-nocheck

import {EntityTypeWithoutEntities, EntityTypeWithoutEntitiesOrTotal} from '/ui/components/entitypicker/cart/cartmodel';
import {EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import {EntityIcon} from '/ui/components/entitypicker/itemlist/entityicon';
import {yext} from '/ui/lib/msg';

/**
 * @param {{
 *   type: (!EntityTypeModel|!EntityTypeWithoutEntities|!EntityTypeWithoutEntitiesOrTotal),
 *   icon: !EntityIcon,
 *   usingEntities: boolean,
 *   onClick: (function(): void),
 *   onSelectAll: ((function(): void)|undefined),
 *   additionalCssClass: (string|undefined),
 *   additionalAttrs: (!Object<string, string|boolean>|undefined),
 * }} props
 * @returns
 */
export function EntityTypeHeader(props) {
  const headingCssClass = `uep-item uep-entity-section-heading ${props.additionalCssClass}`;

  return (
    <div className={headingCssClass}>
      <button
        type="button"
        className="uep-entity-section-title"
        onClick={props.onClick}
        {...props.additionalAttrs}
      >
        <span
          className={`uep-entity-section-icon location-type-icon ${props.icon.typeClass}`}
          {...props.icon.typeAttributes}
        />
        <span>
          {props.usingEntities ? `${props.type.label} (${props.type.total})` : props.type.label}
        </span>
      </button>
      {(props.usingEntities && props.onSelectAll)
        ? <button type="button" onClick={props.onSelectAll} className="uep-entity-section-select-all btn-link">
          {yext.msg('Select All')}
        </button>
        : ''
      }
      {props.usingEntities && props.type.entities && props.type.entities.length > 0
        && <button
          type="button"
          className="uep-entity-section-toggle"
          onClick={props.onClick}
          tabIndex={-1}
          aria-hidden
          {...props.additionalAttrs} />
      }
    </div>);
}
